export const MOBILE = 'MOBILE';
export const DESKTOP = 'DESKTOP';
export const DEFUALT_SUBARU_LOGO =
	'https://images.dealer.com/subaru/pages/love-promise/subaru-logo.jpg';
export const YOUTUBE_EMBED_BASE_URL = 'https://www.youtube.com/embed/';
